@use "@fukuri-admins/ui/layout" as *;

.breadcrumb { width: 100%; }

.list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: spacing("8") 0;
  gap: spacing("8");
}

.item {
  display: inline-flex;
  align-items: center;
  @include typography("Jp/14_W3");
}

.separator {
  display: grid;
  place-content: center;
  user-select: none;

  svg {
    color: text("Low");
  }
}

.link {
  text-decoration: none;
  color: text("Low");
  &:focus { outline: none; }
  &:focus-visible {
    outline: 2px solid border("Focus");
    box-shadow: 0 0 0 2px border("Focus");
    border-radius: 2px;
  }
}

.link:hover { color: text("High"); text-decoration: underline; }
.link:visited { color: text("Low"); }


.ellipsis {
  width: 36px;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: text("Low");
}
